import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Trash, ArrowClockwise, Rocket, ArrowCounterClockwise } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

/** Contextual action row: Edit+Delete (active/other), Renew+Delete (expired), Restore-only (deleted). */
export const ListingCardActions = ({ listing, onDeleteClick, onRestore, onPromote, onRenew }) => {
  const { t } = useTranslation();

  if (listing.status === 'deleted') {
    return (
      <Button
        onClick={() => onRestore(listing.listing_id)}
        variant="primary"
        className="w-full min-h-11 gap-2"
        data-testid="restore-button"
      >
        <ArrowCounterClockwise size={16} weight="bold" />
        {t('listing.restore')}
      </Button>
    );
  }

  if (listing.status === 'expired') {
    return (
      <div className="space-y-2">
        <Button onClick={() => onRenew(listing.listing_id)} variant="primary" className="w-full min-h-11 gap-2" data-testid="renew-button">
          <ArrowClockwise size={16} weight="bold" />
          {t('listing.repost')}
        </Button>
        <div className="flex gap-2">
          <Link to={`/edit/${listing.listing_id}`} className="flex-1">
            <Button variant="secondary" className="w-full min-h-11" data-testid="edit-button">
              {t('listing.edit')}
            </Button>
          </Link>
          <Button
            variant="danger"
            onClick={() => onDeleteClick(listing)}
            className="min-h-11 min-w-11"
            data-testid="delete-button"
            aria-label={t('listing.delete')}
          >
            <Trash size={16} weight="bold" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <Link to={`/edit/${listing.listing_id}`} className="flex-1">
        <Button variant="secondary" className="w-full min-h-11" data-testid="edit-button">
          {t('listing.edit')}
        </Button>
      </Link>
      {listing.status === 'active' && (
        <Button
          variant="secondary"
          onClick={() => onPromote(listing)}
          className="min-h-11 hidden sm:inline-flex"
          data-testid="promote-button"
        >
          <Rocket size={16} weight="bold" />
        </Button>
      )}
      <Button
        variant="danger"
        onClick={() => onDeleteClick(listing)}
        className="min-h-11 min-w-11"
        data-testid="delete-button"
        aria-label={t('listing.delete')}
      >
        <Trash size={16} weight="bold" />
      </Button>
    </div>
  );
};
